<template>
  <div class="container" id="GroupsList">
    <div class="header-container">
      <div class="title">All Groups ({{ groupsCount }})</div>
      <a class="header-all-survey" v-on:click="openModal()">
        VIEW GROUP RESULTS
      </a>
      <b-dropdown
        id="dropdown-1"
        :text="this.orderList"
        ref="dropdown"
        class="m-md-2"
        :disabled="!groups.length"
        v-if="false"
      >
        <TMGeneralButton
          id="buttons"
          @click.native="sortByLatest(groups)"
          text="LATEST"
        />
        <br />
        <TMGeneralButton
          id="buttons"
          @click.native="sortByHighest(groups)"
          text="HIGHEST RESULTS"
        />
        <br />
        <TMGeneralButton
          id="buttons"
          @click.native="sortByLowest(groups)"
          text="LOWEST RESULTS"
        />
      </b-dropdown>
    </div>
    <div class="groups-container" v-for="(data, index) in groups" :key="index">
      <div class="groups-heading">
        <span class="groups-heading-name" v-if="currentUser.admin && shouldDisplay(index)">{{ data.manager_name }}</span>
        <span class="groups-heading-area">Area: {{ data.group_area }}</span>
      </div>
      <b-row
        class="group-container"
        v-for="(group, index_group) in data.groups"
        :key="index_group"
      >
        <b-col xl="1" lg="2" md="2" class="responses-container">
          <div class="responses">{{ group.responses }}</div>
          <span>Responses</span>
        </b-col>
        <b-col xl="3" lg="4" md="4" sm="12" class="group-detail">
          <div class="group-name">
            {{ group.name }} ({{ group.members }} Users)
          </div>
          <span>{{ formatDate(group.creation_date) }}</span>
        </b-col>
        <b-col xl="8" lg="6" md="6">
          <b-row>
            <b-col class="group-metrics" xl="6" lg="12" order-xl="1" order-lg="2" order-md="2" order-sm="2">
              <div
                class="area-metrics"
                v-for="(area, index_area) in areas"
                :key="index_area"
              >
                <div
                  class="score"
                  :style="getColor(Math.round(group.metrics[area]) || 0)"
                >
                  {{ Math.round(group.metrics[area]) || 0 }}%
                </div>
                <div class="area">{{ area }}</div>
              </div>
            </b-col>
            <b-col class="results" xl="6" lg="12" order-xl="2" order-lg="1" order-md="1" order-sm="1">
              <div class="links">
                <a id="mailtosend" v-on:click="getMailtoText(group)">
                  <div
                    class="mail"
                    :class="{ disabled: group.members == group.group_size }"
                  ></div>
                </a>
                <div
                  v-on:click="copyToClipboard(group)"
                  class="link"
                  :class="{ disabled: group.members == group.group_size }"
                ></div>
                <p
                  class="sendSurvey"
                  :class="{ disabled: group.members == group.group_size }"
                >
                  Invite more presenters
                </p>
              </div>
              <div class="button">
                <TMGeneralButton
                  text="GROUP DETAILS"
                  className="blue"
                  route="AdminEditGroup"
                  :routeParams="{ id: group.id }"
                  :disabled="false"
                />
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
    <DashboardModal
      v-if="isSeeAllSurveyResultAvailable"
      title="All Groups' Results"
      ref="DashboardModal"
      :respondents="100"
      :areas="newAreas"
      :questions="questions"
    />
  </div>
</template>

<script>
import axios from "axios";

import TMGeneralButton from "@/components/common/TMGeneralButton";
import Api from "@/services/api";
import { mapState } from "vuex";
import DashboardModal from "@/components/dashboardList/DashboardModal";

import {
  getAuthorizationToken,
  getTmScoreRangeInformationByValue,
  normalizeQuestionsList,
  formatDate,
} from "@/services/utils";

export default {
  name: "GroupsList",
  props: ["groups"],
  data() {
    return {
      areas: ["Content", "Visuals", "Delivery", "Connection"],
      newAreas: {},
      orderList: "LATEST" + Array(30).fill("\xa0").join("") + "▼",
      questions: [],
    };
  },
  computed: {
    ...mapState(["presentations_metrics", "currentUser"]),
    groupsCount(){
      let count = this.groups.reduce((acc, current) => {
        return acc + current.groups.length;
      }, 0);
      return count;
    }
  },
  methods: {
    openModal() {
      let data = [];
      Api()
        .get(`groups/metrics/total_respondents_by_score_of_each_question`, {
          params: {
            user_id: this.currentUser.id,
          },
          headers: {
            Authorization: getAuthorizationToken(),
          },
        })
        .then((res) => {
          if (res.data) {
            data = res.data || [];
            let result = normalizeQuestionsList(data);
            this.newAreas = result.areas;
            this.questions = result.questions;
            this.$refs.DashboardModal.show();
          }
        })
        .catch((err) => console.log(err));
    },
    isSeeAllSurveyResultAvailable() {
      return this.areas;
    },
    getColor(score) {
      return {
        color: getTmScoreRangeInformationByValue(score).color,
      };
    },
    formatDate: formatDate,
    shouldDisplay(index) {
      if(index > 0){
        const prevGrouping = this.groups[index - 1];
        const currentGrouping = this.groups[index];
        if(prevGrouping){
          const prevGroup = prevGrouping.groups[0] || [];
          const currentGroup = currentGrouping.groups[0] || [];
          const prevManager = prevGroup.manager_id || null;
          const currentManager = currentGroup.manager_id || null;
          if(prevManager !== null && prevManager === currentManager) return false;
        }
      }
      return true;
    },
    getMailtoText(group) {
      const customInstance = axios.create({
        baseURL: process.env.VUE_APP_SERVER_URL,
        withCredentials: false,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: getAuthorizationToken(),
        },
      });
      customInstance
        .post(`groups/generate_invitation_token`, null, {
          params: {
            group_id: group.id,
          },
        })
        .then((res) => {
          let message = encodeURI(group.invitation_message) || "";
          let subjet = "You have been invited to use TorchMetrics";
          const auth_token = (res.data && res.data.token) || null;
          let fullURL = "";
          if (auth_token) {
            let path = this.$router.resolve({
              name: "SignUpGroup",
              params: { id: auth_token },
            }).href;

            fullURL = window.location.origin + path;
          }
          message = `${message} ${fullURL}`;
          window.open(`mailto:?subject=${subjet}&body=${message}`);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    copyToClipboard(group) {
      const customInstance = axios.create({
        baseURL: process.env.VUE_APP_SERVER_URL,
        withCredentials: false,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: getAuthorizationToken(),
        },
      });
      customInstance
        .post(`groups/generate_invitation_token`, null, {
          params: {
            group_id: group.id,
          },
        })
        .then((res) => {
          const auth_token = (res.data && res.data.token) || null;
          let fullURL = "";
          if (auth_token) {
            let path = this.$router.resolve({
              name: "SignUpGroup",
              params: { id: auth_token },
            }).href;

            fullURL = window.location.origin + path;
          }
          try {
            navigator.clipboard.writeText(fullURL);
          } catch (e) {
            throw e;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    sortByHighest(array) {
      this.orderList = "HIGHEST RESULTS" + Array(4).fill("\xa0").join("") + "▼";
      let avg = 0;
      array.forEach((presentation) => {
        let sum = Object.keys(presentation.metrics).length
          ? Math.round(presentation.metrics.Content) +
            Math.round(presentation.metrics.Delivery) +
            Math.round(presentation.metrics.Visuals) +
            Math.round(presentation.metrics.Connection)
          : 0;
        avg = sum / Object.keys(presentation.metrics).length;
        presentation.average = sum;
      });
      array.sort((a, b) => b.average - a.average);
    },
    sortByLowest(array) {
      this.orderList = "LOWEST RESULTS" + Array(4).fill("\xa0").join("") + "▼";
      let avg;
      array.forEach((presentation) => {
        let sum = Object.keys(presentation.metrics).length
          ? Math.round(presentation.metrics.Content) +
            Math.round(presentation.metrics.Delivery) +
            Math.round(presentation.metrics.Visuals) +
            Math.round(presentation.metrics.Connection)
          : 0;
        avg = sum / Object.keys(presentation.metrics).length;
        presentation.average = sum;
      });
      array.sort((a, b) => a.average - b.average);
    },
    sortByLatest(array) {
      this.orderList = "LATEST" + Array(30).fill("\xa0").join("") + "▼";
      array.forEach((presentation) => {
        presentation.timestamp = new Date(presentation.creation_date).getTime();
      });
      array.sort(
        (a, b) =>
          new Date(b.creation_date).getTime() -
          new Date(a.creation_date).getTime()
      );
    },
  },
  mounted() {},
  components: {
    TMGeneralButton,
    DashboardModal,
  },
};
</script>

<style lang="less">
@import "../../assets/components/dashboardAdmin/GroupsList.less";
</style>